export default __webpack_public_path__ + "resources/icons/d112-5481.png";